<nz-layout class="app-layout">
    <nz-header>
        <div class="app-header">
            <div class="header-content">
                <div class="header">
                    <div style="width: 50px; margin: 0 auto;padding-left: 9px;">
                        <button nz-button (click)="changeFold()" [ngClass]="{ 'header-padding' : isCollapsed}">
                            <img src="assets/icon/menu.png" height="16">
                        </button>
                    </div>
 
                    <div style="text-align: left;font-size:22px; display: flex;align-items: center;" class="title">
                        <img src="assets/img/sje_logo.png" class="system-logo"/>
                    </div>
                    <div class="actions">
                            <button nz-button class="top-btn-user">
                                <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="user" [nzPlacement]="'bottomCenter'">
                                    <span nz-icon nzType="user_circle" nzTheme="outline" style="font-size: 24px;"></span>
                                    <span class="user-name">
                                        {{userName}}
                                    </span>
                                </a>
                                <nz-dropdown-menu #user>
                                    <ul nz-menu class="drpMenu">
                                        <li nz-menu-item (click)="openUserInfo()">{{'Layout.UserSetting'|translate}}
                                        </li>
                                        <li nz-menu-item (click)="changPwd()">{{'Layout.ModifyPassword'|translate}}</li>
                                        <li nz-menu-item (click)="siginout()">{{'Layout.SignOut'|translate}}</li>
                                    </ul>
                                </nz-dropdown-menu>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
    </nz-header>

    <nz-layout [style]="sliderLeft ? '' : 'justify-content: center;flex-flow: row-reverse;'">
        <nz-sider [nzTheme]="'light'" class="menu-sidebar" [ngClass]="sliderShow ? '' : 'sider-hide' " nzCollapsible
            [(nzCollapsed)]="isCollapsed" [nzWidth]="(isCollapsed ? 48 : 270) + 'px'" [nzTrigger]="null" appDynamicSiderWidth>
            <div class="sider-content" >
                <div class="sider-body-wraper">
                    <div class="sider-body">
                        <mm-sider-menu (addTab)="changeTab($event)" [items]="items$ | async"
                            [mmInlineCollapsed]="isCollapsed"></mm-sider-menu>
                    </div>
                </div>
            </div>
        </nz-sider>
        <nz-content mm-global-spinning>
            <div class="body-taps" *ngIf="breadcrumbs != null && breadcrumbs.length > 0">
                <nz-tabset [(nzSelectedIndex)]="selectedIndex" nzType="editable-card" [nzHideAdd]="true"
                    [ngClass]="{'remove-last': tabs.length<=1}" (nzClose)="closeTab($event)">
                    <nz-tab *ngFor="let tab of tabs" nzClosable [nzTitle]="menuName(tab.name)" (nzClick)="navigateByUrl(tab.url)">
                    </nz-tab>
                </nz-tabset>
            </div>
            <div class="page-body" [class]="breadcrumbs != null && breadcrumbs.length > 1 ? '' : 'no-breadcrumb'">
                <ng-content select="mm-page-body"></ng-content>
            </div>
        </nz-content>
    </nz-layout>
</nz-layout>